<div class="unsubscribe-message">
  <div *ngIf="status === 'PENDING'">Loading...</div>
  <div *ngIf="status === 'SUCCESS'">You have successfully unsubscribed</div>
  <div *ngIf="status === 'ERROR'">Error unsubscribing</div>
</div>
